import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=49147a5c&scoped=true&"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js&"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=49147a5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49147a5c",
  null
  
)

export default component.exports